import React from 'react';
import { COLORS, RandomLoadingMessage } from 'Permafrost/index';
import { StyledLoadingIndicator, StyledMessageLoadingIndicator } from './LoadingIndicator.styles';
export function LoadingIndicator(props) {
    const { className, color, id, overallSize = '200px', rippleSize = '76px', fixedMessage, showRandomMessage, } = props;
    const loadingIndicator = () => {
        return (React.createElement(StyledLoadingIndicator, { "aria-hidden": true, className: className, "data-cy": props['data-cy'], id: id, "$overallSize": returnSizeString(overallSize), "$rippleSize": returnSizeString(rippleSize), style: color ? { color } : { color: COLORS.curiousBlue } }));
    };
    const renderMessage = () => {
        if (fixedMessage) {
            return React.createElement("span", { className: "message" }, fixedMessage);
        }
        if (showRandomMessage) {
            return React.createElement(RandomLoadingMessage, null);
        }
        return null;
    };
    if (fixedMessage || showRandomMessage) {
        return (React.createElement(StyledMessageLoadingIndicator, { "$overallSize": returnSizeString(overallSize) },
            loadingIndicator(),
            renderMessage()));
    }
    return loadingIndicator();
}
function returnSizeString(size) {
    if (typeof size === 'number') {
        return `${size}px`;
    }
    return size;
}
//# sourceMappingURL=LoadingIndicator.js.map